export default {
    namespaced: true,
    state: {
        step: 1,
        model: null,
        versendenNEZOPostfach: null,
        wmiArt: null,
        wmi3Stellen: null,
        wmi6Stellen: null,
        unternehmensbezeichnung: null,
        zusatzUnternehmensbezeichnung: null,
        datenRichtigkeit: false,
        antragsbestaetigung: false,
        dokumentArt: null,
        dokumentArt1: null,
        dokumentArt2: null,
        dokumentArt3: null,
        addDoku1: null,
        addDoku2: null,
        addDoku3: null
    },
    getters: {
        step(state) {
            return state.step
        },
        addDoku1(state) {
            return state.addDoku1
        },
        addDoku2(state) {
            return state.addDoku2
        },
        addDoku3(state) {
            return state.addDoku3
        },
        model(state) {
            return state.model
        },
        dokumentArt(state) {
            return state.dokumentArt
        },
        dokumentArt1(state) {
            return state.dokumentArt1
        },
        dokumentArt2(state) {
            return state.dokumentArt2
        },
        dokumentArt3(state) {
            return state.dokumentArt3
        },
        unternehmensbezeichnung(state) {
            return state.unternehmensbezeichnung
        },
        versendenNEZOPostfach(state) {
            return state.versendenNEZOPostfach
        },
        zusatzUnternehmensbezeichnung(state) {
            return state.zusatzUnternehmensbezeichnung
        },
        wmiArt(state) {
            return state.wmiArt
        },
        wmi3Stellen(state) {
            return state.wmi3Stellen
        },
        wmi6Stellen(state) {
            return state.wmi6Stellen
        },
        datenRichtigkeit(state) {
            return state.datenRichtigkeit
        },
        antragsbestaetigung(state) {
            return state.antragsbestaetigung
        }
    },
    mutations: {
        addDoku1(state, addDoku1) {
            state.addDoku1 = addDoku1
        },
        addDoku2(state, addDoku2) {
            state.addDoku2 = addDoku2
        },
        addDoku3(state, addDoku3) {
            state.addDoku3 = addDoku3
        },
        dokumentArt(state, dokumentArt) {
            state.dokumentArt = dokumentArt
        },
        dokumentArt1(state, dokumentArt1) {
            state.dokumentArt1 = dokumentArt1
        },
        dokumentArt2(state, dokumentArt2) {
            state.dokumentArt2 = dokumentArt2
        },
        dokumentArt3(state, dokumentArt3) {
            state.dokumentArt3 = dokumentArt3
        },
        unternehmensbezeichnung(state, unternehmensbezeichnung) {
            state.unternehmensbezeichnung = unternehmensbezeichnung
        },
        zusatzUnternehmensbezeichnung(state, zusatzUnternehmensbezeichnung) {
            state.zusatzUnternehmensbezeichnung = zusatzUnternehmensbezeichnung
        },
        versendenNEZOPostfach(state, versendenNEZOPostfach) {
            state.versendenNEZOPostfach = versendenNEZOPostfach
        },
        step(state, step) {
            state.step = step
        },
        increaseStep(state) {
            state.step++
        },
        decreaseStep(state) {
            state.step--
        },
        model(state, model) {
            state.model = model
        },
        wmiArt(state, wmiArt) {
            state.wmiArt = wmiArt
        },
        wmi3Stellen(state, wmi3Stellen) {
            state.wmi3Stellen = wmi3Stellen
        },
        wmi6Stellen(state, wmi6Stellen) {
            state.wmi6Stellen = wmi6Stellen
        },
        datenRichtigkeit(state, datenRichtigkeit) {
            state.datenRichtigkeit = datenRichtigkeit
        },
        antragsbestaetigung(state, antragsbestaetigung) {
            state.antragsbestaetigung = antragsbestaetigung
        },
        reset (state) {
            state.loggedin = false
            state.datenRichtigkeit = false
            state.wmiArt = null
            state.wmi3Stellen = null
            state.wmi6Stellen = null
            state.antragsbestaetigung = false
            state.unternehmensbezeichnung = null
            state.zusatzUnternehmensbezeichnung = null
            state.dokumentArt = null
            state.dokumentArt1 = null
            state.dokumentArt2 = null
            state.dokumentArt3 = null
            state.addDoku1 = null
            state.addDoku2 = null
            state.addDoku3 = null
        },
    },
    actions: {}
}
